import React, { Component, PropTypes as T } from 'react';
import { findDOMNode } from 'react-dom';

export default class OutsideClickHandler extends Component {
	static propTypes = {
		onOutsideClick: T.func.isRequired
	};
	static defaultProps = {
		onOutsideClick: () => {}
	};
	componentDidMount() {
		this.handleDocumentClick = this.handleDocumentClick.bind(this);
		document.addEventListener('click', this.handleDocumentClick, true);
	}
	componentWillUnmount() {
	 	document.removeEventListener('click', this.handleDocumentClick, true);
	}
	handleDocumentClick(e) {

		const domNode = findDOMNode(this);

		if (domNode.contains(e.target)) {
			return;
		}

		var closestPortal = e.target.closest(".b3-portal");

		if (closestPortal && domNode.contains(closestPortal.portalOrigin)) {
			return;
		}

		this.props.onOutsideClick(e);

	}

	render() {
		return (
			<div className="outside">{this.props.children}</div>
		);
	}
}


// WEBPACK FOOTER //
// ./app/b3/utils/OutsideClickHandler.js